export default function CsIncidentResponse() {
  return (
    <h2>Cs Incident Response</h2>
  );
}
